/* import __COLOCATED_TEMPLATE__ from './globe.hbs.js'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();